// Module
var code = "<template> Select Tests </template> ";
// Exports
module.exports = code;